import { Grid, GridProps } from '@mui/material';

//
//

export const AppGridContainer = ({
  children,
  container = true,
  spacing = 2,
  ...props
}: GridProps) => (
  <Grid container={container} spacing={spacing} {...props}>
    {children}
  </Grid>
);

//

export const AppGridContent = ({ children, ...props }: GridProps) => {// Omit<Grid2Props, 'component'>
  return <Grid {...props}>{children}</Grid>;
};
